<template>
  <v-layout>
    <v-main>
      <v-container>
        <v-card class="text-h6" style="padding: 1em !important">
          <v-sheet class="text-h4 ma-2 pa2">
            <v-row>
              <v-col class="d-flex justify-center mb-6">
                Unsere Würfe
              </v-col>
            </v-row>
          </v-sheet>
          <v-sheet class="text-h5 ma-2 pa2">
            <v-row>
              <v-col class="d-flex justify-center mb-6">
                Erster Wurf (A-Wurf)
              </v-col>
              <v-col class="d-flex justify-center mb-6">
                <v-img style="max-height: 300px" max-width="60%" :src="kittenImageLink('a', false, 1)" :lazy-src="kittenImageLink('a', true, 1)"></v-img>
                <v-img style="max-height: 300px" max-width="60%" :src="kittenImageLink('a', false, 2)" :lazy-src="kittenImageLink('a', true, 2)"></v-img>
              </v-col>
              <v-col class="d-flex justify-center mb-6">
                <router-link class="text-decoration-underline text-oragne-lighten-3" to="/crew/siri">Nova Scotia's
                  Sirona</router-link> &nbsp;&amp;&nbsp; <a rel="noopener noreferrer" target="_blank"
                  href="http://www.novascotias-mainecoons.de/crew/kater/bibo/"
                  class="text-decoration-underline text-oragne-lighten-3">Nova Scotia’s Big Boss</a>&nbsp;haben Hochzeit
                gefeiert am 22. März
              </v-col>
              <v-col class="d-flex justify-center mb-6">
                Die Kitten sind am 28.05 geboren, den Kitten und der Mutterkatze geht es gut! 😊
              </v-col>
              <v-col class="d-flex justify-center mb-6">
                <v-img max-width="60%" :src="wurfImageLink('a', false)" :lazy-src="wurfImageLink('a', true)"></v-img>
              </v-col>
              <v-col class="d-flex text-h6 justify-center mb-6">
                <v-sheet class="flex-1-0-60 justify-center w-100 ma-2 pa-2">
                  <v-table class="w-100">
                    <thead>
                      <th class="text-center">
                        Name
                      </th>
                      <th class="text-center">
                        Geschlecht
                      </th>
                      <th class="text-center">
                        Fellfarbe
                      </th>
                      <th class="text-center">
                        Fotos
                      </th>
                      <th class="text-center">
                        Vergeben / Reserviert
                      </th>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">Aidan</td>
                        <td class="text-center">Kater ♂️</td>
                        <td class="text-center">
                          <v-tooltip>
                            <template v-slot:activator="{ props }">
                              <v-btn v-bind="props">
                                Blue Solid Smoke
                              </v-btn>
                            </template>
                            <div>Non-Agouti (keine Zeichnung)</div>
                            <div>Verdünnung</div>
                            <div>Smoke (Heterozygot)</div>
                            <div>Kein White/Spotwhite</div>
                            <div>Classic ("überzeichnet" durch Non-Agouti)</div>
                            <div>Black</div>
                          </v-tooltip>
                        </td>
                        <td class="text-center"><u><router-link to="/kitten/aidan">Fotos 📷</router-link></u></td>
                        <td class="text-center">Vergeben</td>
                      </tr>
                      <tr>
                        <td class="text-center">Akira</td>
                        <td class="text-center">Katze ♀️</td>
                        <td class="text-center">
                          <v-tooltip>
                            <template v-slot:activator="{ props }">
                              <v-btn v-bind="props">
                                Black Silver Torbie Classic
                              </v-btn>
                            </template>
                            <div>Agouti / Zeichnung (kann Non-Agouti tragen)</div>
                            <div>Vollfarbe (trägt Verdünnung)</div>
                            <div>Silver (Heterozygot)</div>
                            <div>Kein White/Spotwhite</div>
                            <div>Classic</div>
                            <div>Black + Red</div>
                          </v-tooltip>
                        </td>
                        <td class="text-center"><u><router-link to="/kitten/akira">Fotos 📷</router-link></u></td>
                        <!--td class="text-center">Unter Beobachtung ⏱️</td-->
                        <td class="text-center">Bleibt bei uns 💕</td>
                      </tr>
                      <tr>
                        <td class="text-center">Arely</td>
                        <td class="text-center">Katze ♀️</td>
                        <td class="text-center">
                          <v-tooltip>
                            <template v-slot:activator="{ props }">
                              <v-btn v-bind="props">
                                Blue Tortie Smoke
                              </v-btn>
                            </template>
                            <div>Non-Agouti (keine Zeichnung)</div>
                            <div>Verdünnung</div>
                            <div>Smoke (Heterozygot)</div>
                            <div>Kein White/Spotwhite</div>
                            <div>Classic ("überzeichnet" durch Non-Agouti)</div>
                            <div>Black + Red</div>
                          </v-tooltip>
                        </td>
                        <td class="text-center"><u><router-link to="/kitten/arely">Fotos 📷</router-link></u></td>
                        <td class="text-center">Bleibt bei uns 💕</td>
                      </tr>
                    </tbody>
                  </v-table>
                </v-sheet>
              </v-col>
              <v-col class="d-flex text-h6 justify-center mb-6">
                Frei: Noch zu haben <br />
                Option: Interessenten aber keine feste Reservierung <br />
                Reserviert: Feste Reservierung <br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-card>
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
import { useLinkStore } from "../store/links"

export default {
  setup() {
    const linkStore = useLinkStore();
    return { linkStore };
  },
  methods: {
    wurfImageLink(wurfname, thumbnail) {
      var imagename = wurfname + ".png"
      if (thumbnail) {
        imagename = "thumb." + imagename
      }

      if (process.env.NODE_ENV === 'development') {
        return require("@/assets/static/wurf/" + imagename);
      } else {
        return "https://static.jokingheroes.de/wurf/" + imagename;
      }
    },
    kittenImageLink(wurfname, thumbnail, num) {
      var imagename = wurfname + "_wurf_" + num + ".jpeg"
      if (thumbnail) {
        imagename = "thumb." + imagename
      }

      if (process.env.NODE_ENV === 'development') {
        return require("@/assets/static/kitten/" + imagename);
      } else {
        return "https://static.jokingheroes.de/kitten/" + imagename;
      }
    }
  },
  data: () => ({
  }),
}
</script>
